import { httpCreate } from './http';

const http = httpCreate('/srv/quick-reply');

export const quickReply = {
	// 获取快捷回复词列表
	getQuickList(activityId) {
		return http.get(`/list/${activityId}`);
	},
	/** 新建快捷回复词
	 * @param { Number } data.activityId //直播间id
	 * @param { String } data.quickReplies	//快捷回复词
	 */
	createQuick(data) {
		return http.post('', data);
	},
	/** 删除快捷回复词
	 * @param { Number } quickId //快捷回复词ID
	 */
	deleteQuick(quickId) {
		return http.delete(`/${quickId}`);
	},
};
